import { options_premium_support_title } from './PremiumSupportOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import store from './store/store';
import { getUserConfiguration } from 'owa-session-store';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let PremiumSupportOption: LazyOption = createLazyOption(
    {
        key: 'premium_support',
        titleStringKey: options_premium_support_title,
        searchTermsStringKey: options_premium_support_title,
        isHidden: () =>
            !isFeatureEnabled('auth-PremiumDashboardApril') ||
            !store.isInTreatmentFlight ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
export default PremiumSupportOption;
